module.exports = __webpack_public_path__ + "img/FOPSubindices.44a5758c.png";